export default "__VITE_ASSET__C58sVd6s__"